import React, { Component } from 'react'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import { Paper } from '@material-ui/core'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import SiteActualVsExpected from './SiteActualVsExpected'
import CageActualVsExpected from './CageActualVsExpected'

class ActualVsExpected extends Component {
  constructor(props) {
    super(props)
    this.state = {
      siteLevel: true,
    }
  }

  componentDidUpdate(prevProps) {
    const { activeDate, activeSite } = this.props

    if (
      prevProps.activeDate !== activeDate ||
      prevProps.activeSite !== activeSite
    ) {
      this.setState({ siteLevel: true })
    }
  }

  onGoToCageLevel = () => {
    this.setState({ siteLevel: false })
  }

  onBackToSiteLevel = () => {
    this.setState({ siteLevel: true })
  }

  mobileViewRender = () => {
    const { siteLevel } = this.state

    return (
      <Grid item md={12} sm={12} xs={12}>
        <Paper className="mobile-container">
          <SiteActualVsExpected
            goToCage={this.onGoToCageLevel}
            hideRender={Boolean(siteLevel)}
          />
          {!siteLevel && (
            <CageActualVsExpected
              siteLevel={siteLevel}
              goBack={this.onBackToSiteLevel}
            />
          )}
        </Paper>
      </Grid>
    )
  }

  render() {
    return ifWindowWidthLessThan(992) ? (
      this.mobileViewRender()
    ) : (
      <>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <SiteActualVsExpected />
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <CageActualVsExpected />
        </Grid>
      </>
    )
  }
}

export default connect(state => ({
  activeSite: state.getIn(['profile', 'profile', 'site']),
  activeDate: state.getIn(['slaMonitor', 'activeDate']),
}))(ActualVsExpected)
